import React from 'react';
import RealViewer from './RealViewer';

function App() {
  return <RealViewer />;
}

export default App;
